import { API, authClient } from "../index";

export const postOfferHeader = async (offerHeader, accessToken) => {
  return authClient(accessToken).post(`${API}/offer-headers`, offerHeader);
};

export const postOfferHeaderNewRevision = async (
  id,
  offerHeader,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/offer-headers/${id}`,
    offerHeader
  );
};

export const getOfferHeaders = (accessToken) => {
  return authClient(accessToken).get(`${API}/offer-headers`);
};

export const getOfferHeadersById = (id, accessToken) => {
  return authClient(accessToken).get(`${API}/offer-headers/${id}/all`);
};

export const getOfferHeaderByIdAndRevision = (
  id,
  revisionNumber,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/offer-headers/${id}?revision=${revisionNumber}`
  );
};

export const updateOfferHeader = async (id, offerHeader, accessToken) => {
  return authClient(accessToken).put(`${API}/offer-headers/${id}`, offerHeader);
};

export const updateOfferHeaderStatus = async (
  id,
  revisionNum,
  statusId,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/offer-headers/${id}/${revisionNum}/status?statusId=${statusId}`
  );
};

export const deleteOfferHeader = (id, revisionNum, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/offer-headers/${id}?revision=${revisionNum}`
  );
};
